module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjU0NjY4IDEyLjI4NTJMMS4xMDYxNiAxMi45OTgyQzEuMDQzODUgMTMuMDEwNyAwLjk4ODY1OSAxMi45NTU1IDEuMDAyMDEgMTIuODk0MUwxLjcxNDE1IDkuNDUyNjZMOS41Nzk3MyAxLjU4NjE4QzEwLjM2MjIgMC44MDQ2MDYgMTEuNjMwNyAwLjgwNDYwNiAxMi40MTMyIDEuNTg2MThDMTMuMTk1NiAyLjM2ODY0IDEzLjE5NTYgMy42MzcxNCAxMi40MTMyIDQuNDE5NjFMNC41NDY2OCAxMi4yODUyWiIgc3Ryb2tlPSIjQThCMkM4Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/edit-gray.svg
// module id = UmdH
// module chunks = 27